import { atom, selector } from "recoil";
import { langText } from "../lang-text/langText";

export const langState = atom({
  key: 'langState', 
  default: true
});

export const langSelector = selector({
  key: 'langSelector',
  get: ({get}) => {
    const language = get(langState);
    let Text = language ? langText.ko : langText.en
    return Text
  }
  },
);